import React from 'react';
import { useTranslation } from 'react-i18next';
import ChatMock from '../../components/chat/ChatMock.jsx';
import './ChatSection.css';

/**
 * "Din økonomisjef kan mye mer!": Revetall as an assistant you can ask anything.
 * Example questions as chat bubbles, next to a chat with the fox (`chat.demo`). On phones the
 * chat sits between the lead and the example questions.
 * @returns {JSX.Element} Chat section
 */
function ChatSection() {
  const { t } = useTranslation();
  const questions = t('chat.questions', { returnObjects: true });
  const demoChat = t('chat.demo', { returnObjects: true });

  return (
    <section className="chat-section" aria-labelledby="chat-title">
      <div className="chat-section-content">
        <div className="chat-section-text">
          <h2 className="chat-section-title" id="chat-title">
            {t('chat.title')}
          </h2>
          <p className="chat-section-lead">{t('chat.lead')}</p>
          <p className="chat-section-label">{t('chat.examplesLabel')}</p>
          <ul className="chat-questions" role="list">
            {questions.map((question) => (
              <li key={question} className="chat-question">
                {question}
              </li>
            ))}
          </ul>
        </div>
        <div className="chat-section-art">
          <ChatMock chat={demoChat} />
        </div>
      </div>
    </section>
  );
}

export default ChatSection;
